/** How many m² are in km². It's 1000 * 1000. */
export const M_SQUARED_TO_KM_SQUARED = 1000000;

/** Default maximum area an LSS' polygons can have - 1km². May be overridden by tool permissions. */
export const defaultMaxLssPolygonArea = 1 * M_SQUARED_TO_KM_SQUARED;

/** Maximum number of points an LSS can have. */
export const maxLssPoints = 2500;

/** Minimum spacing (in metres) between generated LSS points. */
export const minLssPointsDensity = 20;
